import { render, staticRenderFns } from "./VerificationInfo.vue?vue&type=template&id=0b0d41fb&scoped=true&"
import script from "./VerificationInfo.vue?vue&type=script&lang=js&"
export * from "./VerificationInfo.vue?vue&type=script&lang=js&"
import style0 from "./VerificationInfo.vue?vue&type=style&index=0&id=0b0d41fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0d41fb",
  null
  
)

export default component.exports